var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.778 4c-2.48 0-3.904 1.307-4.478 1.99a.41.41 0 0 1-.6 0C11.126 5.306 9.702 4 7.222 4 4.378 4 2 6.393 2 9.234c0 6.085 8.677 11.043 9.866 11.694a.272.272 0 0 0 .268 0C13.323 20.277 22 15.318 22 9.234 22 6.394 19.622 4 16.778 4Z"
  })));
};
export default SvgHeart;